import { render, staticRenderFns } from "./FinancialRatio.vue?vue&type=template&id=d0a1fb62"
import script from "./FinancialRatio.vue?vue&type=script&lang=ts"
export * from "./FinancialRatio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports